/**
 * 获取字符串在页面中渲染的宽度
 * @param string - 要获取宽度的字符串
 * @param options - 字符串的字体样式
 */
export function getWidthOfString(
  string: string,
  {
    fontSize,
  }: {
    fontSize?: string;
  } = {}
) {
  // 创建一个隐藏的 <span> 元素，并设置字体样式
  const span = document.createElement("span");
  span.style.visibility = "hidden";
  span.style.position = "absolute";
  span.style.whiteSpace = "nowrap"; // 保证字符串不换行
  span.style.fontSize = fontSize;
  span.innerText = string;

  // 将 <span> 元素插入到 DOM 中以获取其宽度
  document.body.appendChild(span);
  const width = span.offsetWidth;
  document.body.removeChild(span); // 移除 <span> 元素

  return width;
}
